import React from 'react';
import { localDateTime } from '../../Common/timeUtils';
import { i18next } from '@/config/i18n';

export type ColumnKey =
  | 'id'
  | 'optimization_id'
  | 'state'
  | 'timestamp'
  | 'duration'
  | 'triggered'
  | 'range'
  | 'pickups'
  | 'deliveries'
  | 'vehicles'
  | 'directs'
  | 'download';

export interface PlanningColumn {
  id: ColumnKey;
  label: string;
  minWidth?: number;
  align?: 'right' | 'left' | 'center' | 'inherit' | 'justify';
  format?: (format: any) => any;
}

// export enum Status {
//   SUCCESS = 'SUCCESS',
//   FAILURE = 'FAILURE',
//   PENDING = 'PENDING',
// }

export const columns: (minWidth?: number) => readonly PlanningColumn[] = (
  minWidth: number = 170
) => [
  // time when the planning was triggered
  {
    id: 'timestamp', 
    label: i18next.t('common:planning.table.headers.triggered'),
    minWidth: 180,
    format: (date: Date) => localDateTime(new Date(date)),
  },
  // time when the route starts
  { id: 'optimization_id', 
    label: i18next.t('common:planning.table.headers.optimizationId'), 
    minWidth 
  },
];